const KEYS = ["brand", "companyName", "seat", "registry", "taxNumber", "email", "website", "effectiveDate"];

export function interpolateLegalText(text, operator) {
  if (!text) return "";
  let out = String(text);
  const op = operator || {};
  for (const key of KEYS) {
    out = out.split(`{${key}}`).join(String(op[key] ?? ""));
  }
  return out;
}

export function interpolateLegalSections(sections, operator) {
  if (!Array.isArray(sections)) return [];
  return sections.map((sec) => ({
    ...sec,
    body: (sec.body || []).map((p) => interpolateLegalText(p, operator)),
    list: (sec.list || []).map((p) => interpolateLegalText(p, operator)),
  }));
}
